<template>

  <div>

    <!-- show loading indicator -->
    <loading-indicator :loading="isLoading"></loading-indicator>

    <template v-if="!isLoading">

      <v-client-table ref="tblProductPharmacies" name="tblProductPharmacies" :data="table.tblData"
        :columns="table.tblColumns" :options="table.tblOptions" class="tblUsers noFirstColumn">

        <template slot="price" slot-scope="props" >
         € {{ formatPoint2Comma(props.row.price) }}
        </template>

        <template slot="stockType" slot-scope="props" >
         {{ stockTypes.find((st) => st.id == props.row.stockType).label }}
        </template>

        <template slot="offer" slot-scope="props" >

          <template v-if="props.row.offer">

            <template v-if="props.row.offer.displayType == 'p'">
              {{ '-' + Math.round(100 - (props.row.offer.price / props.row.price * 100)) + '%' }}
            </template>

            <template v-else>
              € {{ formatPoint2Comma(props.row.offer.price) }}
            </template>

          </template>

        </template>

        <template slot="loyaltyPoints" slot-scope="props" >
          <div style="display: flex; align-items: center;" v-if="props.row.loyaltyPoints && props.row.loyaltyPoints.loyaltyPoints">
            {{props.row.loyaltyPoints.loyaltyPoints }} 
            <span class="material-symbols-outlined has-pointer" title="Zeige Informationen" style="font-size: 18px; margin-left: 4px;" @click="showInfoModal(props.row.loyaltyPoints)">info</span>
          </div>
        </template>

      </v-client-table>

        
        <VerboseCalculationModal
          :showModal="showModal"
          :loyaltyPoints="informationData && informationData.loyaltyPoints ? informationData.loyaltyPoints : null"
          :informationData="informationData && informationData.info && informationData.info.loyaltyPoints ? informationData.info.loyaltyPoints : null"
          @close="onCloseModal"
        />

    </template>

  </div>

</template>



<script>
import Vue from 'vue';
import { ClientTable } from 'vue-tables-2';
import VerboseCalculationModal from './verboseCalculationModal.vue';
Vue.use(ClientTable, {}, false, 'bulma');

export default {

  name: 'pimProductPharmacyInfo',

  components: {
    VerboseCalculationModal
  },

  data() {

    return {
      isLoading: false,
      productId: null,
      pharmacies: null,
      stockTypes: [
        { label: 'verfügbar', id: 'available' },
        { label: 'momentan nicht verfügbar', id: 'currently-not-available' },
        { label: 'nicht verfügbar', id: 'not-available' },
        { label: 'lokal verfügbar', id: 'local' },
        { label: 'ohne Status', id: 'none' },
      ],

      table: {
        tblData: [],
        tblColumns: ['name', 'price', 'stockType', 'offer', 'loyaltyPoints'],
        tblOptions: {

          trackBy: 'id',
          uniqueKey: 'id',
          saveState: true,
          sortIcon: {
            base: 'fa',
            up: 'fa-sort-up',
            down: 'fa-sort-down',
            is: 'fa-sort'
          },

          perPage: 25,

          orderBy: {
            ascending: true,
            column: 'name'
          },

          headings: {
            
            name: function (h) {
              return <lang labelKey="TBL_HEADER-PIM-PHARMACY_NAME"></lang>
            },
            price: function (h) {
              return <lang labelKey="TBL_HEADER-PIM-PHARMACY_PRICE"></lang>
            },
            stockType: function (h) {
              return <lang labelKey="TBL_HEADER-PIM-PHARMACY_STOCKTYPE"></lang>
            },
            offer: function (h) {
              return <lang labelKey="TBL_HEADER-PIM-PHARMACY_OFFER"></lang>
            },
            loyaltyPoints: function (h) {
              return <lang labelKey="TBL_HEADER-PIM-PHARMACY_LOYALTY_POINTS"></lang>
            },
          },

          sortable: ['name', 'price', 'stockType'],

          texts: {
            filter: 'Filter Ergebnisse:',
            filterPlaceholder: 'Suche',
            limit: 'Einträge pro Seite',
            noResults: 'keine passenden Einträge gefunden',
            count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
          },

          pagination: {
            chunk: 5
          },

          filterByColumn: false,
          filterable: false,
          skin: 'table is-striped is-hoverable is-fullwidth',

          columnsClasses: {
              'name': 'name',
              'price': 'price',
              'stockType': 'stockType',
              'offer': 'offer',
              'loyaltyPoints': 'loyaltyPoints',
          },

          // custom filter functions
          customFilters: [

          ],

        }
      },

      showModal: false,
      informationData: null,
    }

  },

  created() {

    this.productId = this.$route.params.id;
    this.init();

  },

  methods: {

    init() {

      this.isLoading = true;

      // this.axios.get('https://mwb.sanodattest.bdata.at/herba/public/api/pimProduct/457275/sites')
      this.axios.get(`${this.$config.api}pimProduct/${this.productId}/sites`)
        .then(res => {
          res.data.data.forEach((s) => s.name = s.site.name);
          this.table.tblData = res.data.data;
        })
        .finally(() => {
          this.isLoading = false;
        })

    },

    showInfoModal(data) {
      this.informationData = data;
      this.showModal = true;
    },

    onCloseModal() {
      this.showModal = false;
      this.informationData = null;  
    }

  }

}

</script>


<style lang="scss" scoped>


::v-deep .VueTables__table {

  .price {
    width: 10%;
    max-width: 100px;
    min-width: 100px;
  }
  .stockType {
    width: 10%;
    max-width: 200px;
    min-width: 150px;
  }
  .offer {
    width: 10%;
  }
  .loyaltyPoints {
    width: 10%;
    max-width: 100px;
    min-width: 100px;
  }
}



</style>